import React, { useState } from "react";
import "../styles/Skills.css";
import { GoServer } from "react-icons/go";
import { AiOutlineFilter } from "react-icons/ai";

const Skills = () => {
  const [expandedCategories, setExpandedCategories] = useState({
    frontend: false,
    backend: false,
    seo: false,
  });

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <section id="skills" className="skills">
      <h2>Skills</h2>
      <h3>
        My <span>Technical Level</span>
      </h3>
      <div className="skills-grid">
        {/* Frontend Developer */}
        <div className="skill-category">
          <h4>
            <i className="bi bi-braces"></i> Frontend Developer
          </h4>
          <p>More than 6 years</p>
          <button
            onClick={() => toggleCategory("frontend")}
            className="toggle-button"
          >
            {expandedCategories.frontend ? (
              <>
                <i className="fas fa-chevron-up"></i> Show Less
              </>
            ) : (
              <>
                <i className="fas fa-chevron-down"></i> Show More
              </>
            )}
          </button>
          {expandedCategories.frontend && (
            <div className="skill-details">
              <div className="skill-item">
                <span>HTML/CSS/</span>
                <span>2 years</span>
              </div>
              <div className="skill-item">
                <span>JS/React/</span>
                <span>about a year</span>
              </div>
              <div className="skill-item">
                <span>Gatsby/NextJS/Netlify</span>
                <span>fresher</span>
              </div>
            </div>
          )}
        </div>

        {/* Backend Developer */}
        <div className="skill-category">
          <h4>
            {" "}
            <i>
              <GoServer />
            </i>{" "}
            Backend Developer
          </h4>
          <p>More than 2 years</p>{" "}
          <button
            onClick={() => toggleCategory("backend")}
            className="toggle-button"
          >
            {expandedCategories.backend ? (
              <>
                <i className="fas fa-chevron-up"></i> Show Less
              </>
            ) : (
              <>
                <i className="fas fa-chevron-down"></i> Show More
              </>
            )}
          </button>
          {expandedCategories.backend && (
            <div className="skill-details">
              <div className="skill-item">
                <span>PHP//MySQL</span>
                <span>2 years</span>
              </div>
              <div className="skill-item">
                <span>NodeJS/NestJS</span>
                <span>1 year</span>
              </div>
              <div className="skill-item">
                <span>Firebase/Socket.io</span>
                <span>Around 1 year</span>
              </div>
            </div>
          )}
        </div>

        {/* SEO Engineer */}
        <div className="skill-category">
          <h4>
            {" "}
            <i>
              <AiOutlineFilter />
            </i>{" "}
            SEO
          </h4>
          <p>About 3 months</p>
          <button
            onClick={() => toggleCategory("seo")}
            className="toggle-button"
          >
            {expandedCategories.seo ? (
              <>
                <i className="fas fa-chevron-up"></i> Show Less
              </>
            ) : (
              <>
                <i className="fas fa-chevron-down"></i> Show More
              </>
            )}
          </button>
          {expandedCategories.seo && (
            <div className="skill-details">
              <div className="skill-item">
                <span>Technical SEO</span>
                <span>3 months </span>
              </div>
              <div className="skill-item">
                <span>Image Optimization</span>
                <span>3 months</span>
              </div>
              <div className="skill-item">
                <span>Content Building</span>
                <span>Around 1 year</span>
              </div>
              <div className="skill-item">
                <span>SEO analysis</span>
                <span>4 months</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Skills;
